/**
 * Cookie Banner Component
 * Neumorphic cookie consent banner for Fashion.Catalog theme
 * Uses Alpine.js for UI interactions only, follows server cookie logic
 */
export default function cookieBanner() {
  return {
    isVisible: false,
    isProcessing: false,

    init() {
      // Only show if no cookie decision has been made
      if (!document.cookie.match(/cookies_accepted=/)) {
        this.isVisible = true;
      }
    },

    accept() {
      if (this.isProcessing) return;
      this.isProcessing = true;

      // Set acceptance cookie (1 year)
      const expiry = new Date();
      expiry.setFullYear(expiry.getFullYear() + 1);
      document.cookie = `cookies_accepted=1; expires=${expiry.toUTCString()}; path=${window.WS_DIR_APP || '/'}; SameSite=Lax`;

      // Trigger custom event for other scripts
      window.dispatchEvent(new CustomEvent('cookiesAccepted'));

      // Hide banner with animation
      this.hide();
    },

    decline() {
      if (this.isProcessing) return;
      this.isProcessing = true;

      // Set decline cookie (session only)
      document.cookie = `cookies_accepted=0; path=${window.WS_DIR_APP || '/'}; SameSite=Lax`;

      // Hide banner with animation
      this.hide();
    },

    hide() {
      this.isVisible = false;
      this.isProcessing = false;
    },

    get policyUrl() {
      // Get cookie policy page from server settings
      if (window.fashionSettings?.cookiePolicyId) {
        return `${window.WS_DIR_APP || '/'}index.php?route=information/information&information_id=${window.fashionSettings.cookiePolicyId}`;
      }
      return '#';
    },

    get message() {
      return (
        window.fashionTranslations?.cookieNotice ||
        'We rely on <a href="%url" class="underline hover:text-[var(--color-accent)] transition-colors">cookies</a> for storing your shopping cart and regional settings between visits and to understand how our customers use our website.'
      );
    },
  };
}
